import { createFileRoute } from "@tanstack/react-router"
import { ReverConfiguration } from "modules/settings/components/integrations/rever"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/rever")({
  component: ReverConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.rever.title"),
    })
  },
})
